import { childrenInfoAdapter } from '@/auth/adapters/authAdapters';

export default class QueriesController {
  _requestService;
  _paths;
  _persistance;
  _store;

  constructor(requestService, paths, persistance, store) {
    this._requestService = requestService;
    this._paths = paths;
    this._persistance = persistance;
    this._store = store;
  }

  async fetchUserData() {
    return new Promise((resolve, reject) => {
      this._requestService
        .Get(this._paths.userInfo)
        .then(({ data }) => {
          let parentName = '';
          let parentId = '';
          if (data.parent) {
            let { id, name } = data.parent;
            parentName = name;
            parentId = id;
          }
          const profileInformation = {
            userType: data.is_child ? 'child' : 'parent',
            userId: data.id,
            isFirstTime: data.is_first_time,
            userName: data.name,
            userLastName: data.last_name,
            parentId: parentId,
            parentName: parentName,
            userEmail: data.email || '',
          };
          this.saveProfileData(profileInformation);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async fetchChildDataRequest(userId) {
    const { data } = await this._requestService.Get(this._paths.childInfoPath(userId));
    this._store.childInfo = childrenInfoAdapter([{ child: data }])[0];
    return data;
  }

  async fetchChildrenInfo(userId) {
    const { data } = await this._requestService.Get(this._paths.childrenInfoPath(userId));
    this._store.children = childrenInfoAdapter(data);
    return data;
  }

  async fetchParentDataRequest(userId) {
    const { data } = await this._requestService.Get(this._paths.parentInfoPath(userId));
    return data;
  }

  saveProfileData(profileInformation) {
    const {
      userType,
      userId,
      isFirstTime,
      userName,
      userLastName,
      parentId,
      parentName,
      userEmail,
    } = profileInformation;

    this._store.profileType = userType;
    this._store.userId = userId;
    this._store.isFirstTime = isFirstTime;
    this._store.userName = userName;
    this._store.userLastName = userLastName;
    this._store.childSelectedId = this._persistance.getPersistedVar('childSelected') ?? '';
    this._store.parentId = parentId;
    this._store.parentName = parentName;
    this._store.userEmail = userEmail;
  }
}
